"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "camporotondo-di-fiastrone": {
    "3a15b40a": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-carufo": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1a3cb26": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-case-nuove": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f15eb05d": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-ceca": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b563048b": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-palombare": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c30d9ff": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-contrada-colvenale": [{
      "hkey": "2dd176b2",
      "slug": "camporotondo-di-fiastrone",
      "name": "Camporotondo di Fiastrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;